/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbSharedRefineMenuRadioSelectSearch_searchBrowse$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedRefineMenuFilterLocation_searchBrowse$ref: FragmentReference;
export type SbSharedRefineMenuFilterLocation_searchBrowse = {|
  +appliedFilters: ?$ReadOnlyArray<?{|
    +name: ?string,
    +values: ?$ReadOnlyArray<?{|
      +code: ?string
    |}>,
  |}>,
  +$fragmentRefs: SbSharedRefineMenuRadioSelectSearch_searchBrowse$ref,
  +$refType: SbSharedRefineMenuFilterLocation_searchBrowse$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilterLocation_searchBrowse",
  "type": "SearchBrowseQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuRadioSelectSearch_searchBrowse",
      "args": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "appliedFilters",
      "storageKey": null,
      "args": null,
      "concreteType": "SearchBrowseParsedParam",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "values",
          "storageKey": null,
          "args": null,
          "concreteType": "SearchBrowseParsedParamValue",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "code",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'ed2b8389741f476c7eebc68248878f8a';
module.exports = node;
